(() => {
  const initCountdown = (root) => {
    root.querySelectorAll("[data-velvet-countdown]").forEach((timer) => {
      if (timer.dataset.initialized === "true") return;
      timer.dataset.initialized = "true";

      const configuredEnd = Date.parse(timer.dataset.end || "");
      const duration = Number(timer.dataset.duration || 240) * 60 * 1000;
      const storageKey = `velvet-countdown-${window.location.pathname}`;
      let endTime = Number.isFinite(configuredEnd) ? configuredEnd : Number(sessionStorage.getItem(storageKey));

      if (!endTime || endTime <= Date.now()) {
        endTime = Date.now() + duration;
        if (!Number.isFinite(configuredEnd)) sessionStorage.setItem(storageKey, String(endTime));
      }

      const hours = timer.querySelector("[data-hours]");
      const minutes = timer.querySelector("[data-minutes]");
      const seconds = timer.querySelector("[data-seconds]");

      const update = () => {
        const distance = Math.max(0, endTime - Date.now());
        hours.textContent = String(Math.floor(distance / 3600000)).padStart(2, "0");
        minutes.textContent = String(Math.floor((distance % 3600000) / 60000)).padStart(2, "0");
        seconds.textContent = String(Math.floor((distance % 60000) / 1000)).padStart(2, "0");

        if (distance <= 0) {
          timer.hidden = true;
          window.clearInterval(interval);
        }
      };

      update();
      const interval = window.setInterval(update, 1000);
    });
  };

  const init = (root = document) => initCountdown(root);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));

  document.addEventListener("variant:changed", (event) => {
    const variant = event.detail?.variant;
    if (!variant) return;

    document.querySelectorAll("[data-velvet-sale-badge]").forEach((badge) => {
      badge.hidden = !(Number(variant.compare_at_price) > Number(variant.price));
    });
  });
})();
